//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  TextField,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer';
import { ExpressionContext } from '../../../Context/ExpressionContext';
import { DataTypeSelect    } from '../DataTypeSelect/DataTypeSelect';

// === API ===
import { on, removeListener, requestFile } from 'api/prokey/prokey.websocket';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function ConstantControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { updateExpression } = useContext( ExpressionContext );
  
  const [ text, setText ] = useState( props.data?.value );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    text_value: {
      width: '40rem',
    },
  }

  const TEXT_VALUE = {
    sx    : _styles.text_value,
    value : text,
    size  : 'small',
    onChange  : onChange  ,
    onKeyDown : onKeyDown ,
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    setText( event.target.value );
    // updateExpression( props.id , { value: event.target.value } )
  }
  
  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    if (event.key === 'Enter') {
      updateExpression( props.id , { value: event.target.value } );
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <DataTypeSelect id={props.id} type={props.data?.type} />
        <Spacer />
        <TextField { ...TEXT_VALUE } />
      </>
    );
  }

  //#endregion

  return display();
}
